import React from 'react';
import Box from '@mui/material/Box';
import { WHITE } from '../../common/colors';

// 52px brand rounded-square icon tile (Webflow layout item icons).
const IconTile = ({ icon: Icon, sx }) => (
  <Box
    sx={{
      width: 52,
      height: 52,
      borderRadius: '10px',
      backgroundColor: 'primary.main',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}>
    <Icon sx={{ color: WHITE, fontSize: 30 }} />
  </Box>
);

export default IconTile;
